import { cards as cardsAT } from './lib/featureConfig/AT';
import { cards as cardsBase } from './lib/featureConfig/base';
import { cards as cardsCZ } from './lib/featureConfig/CZ';
import { cards as cardsHR } from './lib/featureConfig/HR';
import { cards as cardsHU } from './lib/featureConfig/HU';
import { cards as cardsRO } from './lib/featureConfig/RO';
import { cards as cardsRS } from './lib/featureConfig/RS';
import { cards as cardsSK } from './lib/featureConfig/SK';
import { cards as cardsGatekeeperAT } from './lib/featureMap/cards/AT';
import { cards as cardsGatekeeperCZ } from './lib/featureMap/cards/CZ';
import { cards as cardsGatekeeperHR } from './lib/featureMap/cards/HR';
import { cards as cardsGatekeeperHU } from './lib/featureMap/cards/HU';
import { cards as cardsGatekeeperRO } from './lib/featureMap/cards/RO';
import { cards as cardsGatekeeperRS } from './lib/featureMap/cards/RS';
import { cards as cardsGatekeeperSK } from './lib/featureMap/cards/SK';
import { cardActivationFlowV2 as cardActivationFlowV2AT } from './lib/featureMap/card-activation/AT';
import { cardActivationFlowV2 as cardActivationFlowV2CZ } from './lib/featureMap/card-activation/CZ';
import { cardActivationFlowV2 as cardActivationFlowV2HR } from './lib/featureMap/card-activation/HR';
import { cardActivationFlowV2 as cardActivationFlowV2HU } from './lib/featureMap/card-activation/HU';
import { cardActivationFlowV2 as cardActivationFlowV2RO } from './lib/featureMap/card-activation/RO';
import { cardActivationFlowV2 as cardActivationFlowV2RS } from './lib/featureMap/card-activation/RS';
import { cardActivationFlowV2 as cardActivationFlowV2SK } from './lib/featureMap/card-activation/SK';
import { cardClosingInfoScreen as cardClosingInfoScreenAT } from './lib/featureMap/card-closing-info-screen/AT';
import { cardClosingInfoScreen as cardClosingInfoScreenCZ } from './lib/featureMap/card-closing-info-screen/CZ';
import { cardClosingInfoScreen as cardClosingInfoScreenHR } from './lib/featureMap/card-closing-info-screen/HR';
import { cardClosingInfoScreen as cardClosingInfoScreenHU } from './lib/featureMap/card-closing-info-screen/HU';
import { cardClosingInfoScreen as cardClosingInfoScreenRO } from './lib/featureMap/card-closing-info-screen/RO';
import { cardClosingInfoScreen as cardClosingInfoScreenRS } from './lib/featureMap/card-closing-info-screen/RS';
import { cardClosingInfoScreen as cardClosingInfoScreenSK } from './lib/featureMap/card-closing-info-screen/SK';
import { cardCancellationWarning as cardCancellationWarningAT } from './lib/featureMap/card-cancellation-warning/AT';
import { cardCancellationWarning as cardCancellationWarningCZ } from './lib/featureMap/card-cancellation-warning/CZ';
import { cardCancellationWarning as cardCancellationWarningHR } from './lib/featureMap/card-cancellation-warning/HR';
import { cardCancellationWarning as cardCancellationWarningHU } from './lib/featureMap/card-cancellation-warning/HU';
import { cardCancellationWarning as cardCancellationWarningRO } from './lib/featureMap/card-cancellation-warning/RO';
import { cardCancellationWarning as cardCancellationWarningRS } from './lib/featureMap/card-cancellation-warning/RS';
import { cardCancellationWarning as cardCancellationWarningSK } from './lib/featureMap/card-cancellation-warning/SK';
import { newCardLimitChange as newCardLimitChangeAT } from './lib/featureMap/new-card-limit-change/AT';
import { newCardLimitChange as newCardLimitChangeCZ } from './lib/featureMap/new-card-limit-change/CZ';
import { newCardLimitChange as newCardLimitChangeHR } from './lib/featureMap/new-card-limit-change/HR';
import { newCardLimitChange as newCardLimitChangeHU } from './lib/featureMap/new-card-limit-change/HU';
import { newCardLimitChange as newCardLimitChangeRO } from './lib/featureMap/new-card-limit-change/RO';
import { newCardLimitChange as newCardLimitChangeRS } from './lib/featureMap/new-card-limit-change/RS';
import { newCardLimitChange as newCardLimitChangeSK } from './lib/featureMap/new-card-limit-change/SK';
import { newBlockReorderFunction as newBlockReorderFunctionAT } from './lib/featureMap/new-block-reorder-function/AT';
import { newBlockReorderFunction as newBlockReorderFunctionCZ } from './lib/featureMap/new-block-reorder-function/CZ';
import { newBlockReorderFunction as newBlockReorderFunctionHR } from './lib/featureMap/new-block-reorder-function/HR';
import { newBlockReorderFunction as newBlockReorderFunctionHU } from './lib/featureMap/new-block-reorder-function/HU';
import { newBlockReorderFunction as newBlockReorderFunctionRO } from './lib/featureMap/new-block-reorder-function/RO';
import { newBlockReorderFunction as newBlockReorderFunctionRS } from './lib/featureMap/new-block-reorder-function/RS';
import { newBlockReorderFunction as newBlockReorderFunctionSK } from './lib/featureMap/new-block-reorder-function/SK';
import { repaymentMethodChange as repaymentMethodChangeAT } from './lib/featureMap/repayment-method-change/AT';
import { repaymentMethodChange as repaymentMethodChangeCZ } from './lib/featureMap/repayment-method-change/CZ';
import { repaymentMethodChange as repaymentMethodChangeHR } from './lib/featureMap/repayment-method-change/HR';
import { repaymentMethodChange as repaymentMethodChangeHU } from './lib/featureMap/repayment-method-change/HU';
import { repaymentMethodChange as repaymentMethodChangeRO } from './lib/featureMap/repayment-method-change/RO';
import { repaymentMethodChange as repaymentMethodChangeRS } from './lib/featureMap/repayment-method-change/RS';
import { repaymentMethodChange as repaymentMethodChangeSK } from './lib/featureMap/repayment-method-change/SK';
import { creditLimitChange as creditLimitChangeAT } from './lib/featureMap/credit-limit-change/AT';
import { creditLimitChange as creditLimitChangeCZ } from './lib/featureMap/credit-limit-change/CZ';
import { creditLimitChange as creditLimitChangeHU } from './lib/featureMap/credit-limit-change/HU';
import { creditLimitChange as creditLimitChangeHR } from './lib/featureMap/credit-limit-change/HR';
import { creditLimitChange as creditLimitChangeRO } from './lib/featureMap/credit-limit-change/RO';
import { creditLimitChange as creditLimitChangeRS } from './lib/featureMap/credit-limit-change/RS';
import { creditLimitChange as creditLimitChangeSK } from './lib/featureMap/credit-limit-change/SK';

export type { CardFeatures } from './lib/CardFeatures';

export const cards = {
    AT: cardsAT,
    base: cardsBase,
    CZ: cardsCZ,
    HR: cardsHR,
    HU: cardsHU,
    RO: cardsRO,
    RS: cardsRS,
    SK: cardsSK,
};

export const cardsGatekeeper = {
    AT: cardsGatekeeperAT,
    CZ: cardsGatekeeperCZ,
    HR: cardsGatekeeperHR,
    HU: cardsGatekeeperHU,
    RO: cardsGatekeeperRO,
    RS: cardsGatekeeperRS,
    SK: cardsGatekeeperSK,
};

export const cardActivationFlowV2 = {
    AT: cardActivationFlowV2AT,
    CZ: cardActivationFlowV2CZ,
    HR: cardActivationFlowV2HR,
    HU: cardActivationFlowV2HU,
    RO: cardActivationFlowV2RO,
    RS: cardActivationFlowV2RS,
    SK: cardActivationFlowV2SK,
};

export const cardClosingInfoScreen = {
    AT: cardClosingInfoScreenAT,
    CZ: cardClosingInfoScreenCZ,
    HR: cardClosingInfoScreenHR,
    HU: cardClosingInfoScreenHU,
    RO: cardClosingInfoScreenRO,
    RS: cardClosingInfoScreenRS,
    SK: cardClosingInfoScreenSK,
};

export const cardCancellationWarning = {
    AT: cardCancellationWarningAT,
    CZ: cardCancellationWarningCZ,
    HR: cardCancellationWarningHR,
    HU: cardCancellationWarningHU,
    RO: cardCancellationWarningRO,
    RS: cardCancellationWarningRS,
    SK: cardCancellationWarningSK,
};

export const newCardLimitChange = {
    AT: newCardLimitChangeAT,
    CZ: newCardLimitChangeCZ,
    HR: newCardLimitChangeHR,
    HU: newCardLimitChangeHU,
    RO: newCardLimitChangeRO,
    RS: newCardLimitChangeRS,
    SK: newCardLimitChangeSK,
};

export const newBlockReorderFunction = {
    AT: newBlockReorderFunctionAT,
    CZ: newBlockReorderFunctionCZ,
    HR: newBlockReorderFunctionHR,
    HU: newBlockReorderFunctionHU,
    RO: newBlockReorderFunctionRO,
    RS: newBlockReorderFunctionRS,
    SK: newBlockReorderFunctionSK,
};

export const repaymentMethodChange = {
    AT: repaymentMethodChangeAT,
    CZ: repaymentMethodChangeCZ,
    HR: repaymentMethodChangeHR,
    HU: repaymentMethodChangeHU,
    RO: repaymentMethodChangeRO,
    RS: repaymentMethodChangeRS,
    SK: repaymentMethodChangeSK,
};

export const creditLimitChange = {
    AT: creditLimitChangeAT,
    CZ: creditLimitChangeCZ,
    HR: creditLimitChangeHR,
    HU: creditLimitChangeHU,
    RO: creditLimitChangeRO,
    RS: creditLimitChangeRS,
    SK: creditLimitChangeSK,
};
